import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  
  private countryData = new BehaviorSubject<Object>({});

  countryVal$ = this.countryData.asObservable();

  setCountryValue(countryVal: Object) {
    this.countryData.next(countryVal)
  }

  constructor() { }

}
